import i18n from 'modules/core/lib/i18n'

import { InsightTableGroupBy } from 'modules/finance/components/FinancialWorkspace/types/table'

export const groups = () => [
  {
    label: i18n.t('finance.financial_workspace.breakdown_table.segment_by.employees'),
    value: InsightTableGroupBy.Employee,
  },
  {
    label: i18n.t('finance.financial_workspace.breakdown_table.segment_by.legal_entities'),
    value: InsightTableGroupBy.LegalEntity,
  },
  {
    label: i18n.t('finance.financial_workspace.breakdown_table.segment_by.workplaces'),
    value: InsightTableGroupBy.Location,
  },
  {
    label: i18n.t('finance.financial_workspace.breakdown_table.segment_by.managers'),
    value: InsightTableGroupBy.Manager,
  },
  {
    label: i18n.t('finance.financial_workspace.breakdown_table.segment_by.cost_centers'),
    value: InsightTableGroupBy.CostCenter,
  },
]

export const resolveTitle = (group?: string) => {
  switch (group) {
    case InsightTableGroupBy.Employee:
      return i18n.t('finance.financial_workspace.breakdown_table.segment_by.employees')
    case InsightTableGroupBy.LegalEntity:
      return i18n.t('finance.financial_workspace.breakdown_table.segment_by.legal_entities')
    case InsightTableGroupBy.Location:
      return i18n.t('finance.financial_workspace.breakdown_table.segment_by.workplaces')
    case InsightTableGroupBy.Manager:
      return i18n.t('finance.financial_workspace.breakdown_table.segment_by.managers')
    default:
      return i18n.t('finance.financial_workspace.breakdown_table.segment_by.payroll_concept')
  }
}
